import React, { useEffect } from 'react'
import Box from '@material-ui/core/Box'
import PlayerReportWinlossAnalyzeForm from '../../../components/admin/playerReport/winlossAnalyze/PlayerReportWinlossAnalyzeForm'
import PlayerReportWinlossAnalyzeTable from '../../../components/admin/playerReport/winlossAnalyze/PlayerReportWinlossAnalyzeTable'
import useGDK from '../../../providers/admin/gdk/useGDK'
import { Branch } from '@golden/gdk-admin'

const PlayerReportCashAccountingPage: React.FC = () => {
  const gdk = useGDK()
  useEffect(() => {
    gdk.trunk.trigger([Branch.PLATFORMS, Branch.PUBLISHERS])
  }, [gdk])
  return (
    <Box paddingY={5}>
      <Box paddingX={5}>
        <PlayerReportWinlossAnalyzeForm />
      </Box>
      <Box paddingTop={3}>
        <PlayerReportWinlossAnalyzeTable />
      </Box>
    </Box>
  )
}

export default React.memo(PlayerReportCashAccountingPage)
